
import { PJAxios, usePJStore } from '@jaf/jaf-react-core';
import { Button } from 'primereact/button';
import { Card } from 'primereact/card';
import { ProgressSpinner } from 'primereact/progressspinner';
import React, { useEffect, useState } from 'react';
import { flushCache } from '../../../api/ChatbotApi';

function SpostaNodo(props) {

    const getText = usePJStore((state) => state.i18n_getText)
    const dbTest = usePJStore((state) => state.appInfo_dbTest);
    const { storage } = usePJStore((state) => state.storage)


    const [loading,setLoading] = useState(false);
    const [modifiedNodes,setModifiedNodes] = useState([])

    const salvaTutto = () => {
        setLoading(true);
        PJAxios().post('/gestioneConfigurazioni/salvaTutto', { operazioni: modifiedNodes, idConfig: props.tematica.id_config }).then((res) => {
            props.onSave(props.tematica, true);
            setModifiedNodes([]);
            flushCache(dbTest);
            setLoading(false);
        });
    }

    

    const nodoGiu = () => {

        setModifiedNodes([]);

        var item = {
            is_new: false,
            id_tree: "jstree_tematica",
            op_type: "move",
            obj_type: "Q" === props.selectedNode.nodeType ? "itemFaq" : "",

            id_node_old_parent: props.selectedNode.idParent,
            old_position: props.selectedNode.itemOrder,
            id_node_parent: props.selectedNode.idParent,
            id_item_parent: props.selectedNode.idItemParent,

            position: props.selectedNode.itemOrder + 1,
            id_item: props.selectedNode.idItem,
            id_node: props.selectedNode.idNode
        }

        modifiedNodes.push(item)
        setModifiedNodes(modifiedNodes)

        salvaTutto();
    }

    const nodoTop = () => {

        setModifiedNodes([]);

        var item = {
            is_new: false,
            id_tree: "jstree_tematica",
            op_type: "move",
            obj_type: "Q" === props.selectedNode.nodeType ? "itemFaq" : "",
            id_node_old_parent: props.selectedNode.idParent,
            old_position: props.selectedNode.itemOrder,
            id_node_parent: props.selectedNode.idParent,
            id_item_parent: props.selectedNode.idItemParent,
            position: 0,
            id_item: props.selectedNode.idItem,
            id_node: props.selectedNode.idNode
        }

        modifiedNodes.push(item)
        setModifiedNodes(modifiedNodes)

        salvaTutto();
    }

    const nodoBottom = () => {
        setModifiedNodes([]);

        let position = props.selectedNode.children - 1;

        var item = {
            is_new: false,
            id_tree: "jstree_tematica",
            op_type: "move",
            obj_type: "Q" === props.selectedNode.nodeType ? "itemFaq" : "",
            id_node_old_parent: props.selectedNode.idParent,
            old_position: props.selectedNode.itemOrder,
            id_node_parent: props.selectedNode.idParent,
            id_item_parent: props.selectedNode.idItemParent,
            position: position,
            id_item: props.selectedNode.idItem,
            id_node: props.selectedNode.idNode
        }

        modifiedNodes.push(item)
        setModifiedNodes(modifiedNodes)

        salvaTutto();
    }


    const nodoSu = () => {

        setModifiedNodes([]);

        var item = {
            is_new: false,
            id_tree: "jstree_tematica",
            op_type: "move",
            obj_type: "Q" === props.selectedNode.nodeType ? "itemFaq" : "M" === props.selectedNode.nodeType ? "menu" : "",
            id_node_old_parent: props.selectedNode.idParent,
            old_position: props.selectedNode.itemOrder,
            id_node_parent: props.selectedNode.idParent,
            id_item_parent: props.selectedNode.idItemParent,
            position: props.selectedNode.itemOrder - 1,
            id_item: props.selectedNode.idItem,
            id_node: props.selectedNode.idNode
        }

        modifiedNodes.push(item)
        setModifiedNodes(modifiedNodes)
        salvaTutto();
    }

    const isOnTop = () => {
        //return ((props.selectedNode.itemOrder === 1 && props.selectedNode.nodeType != null && props.selectedNode.nodeType === 'M') || props.selectedNode.itemOrder === 0)
        return props.selectedNode.itemOrder === 0
    }

    const withoutHeading = () => {
        return <div style={{display: "none" }}></div>
    }

    return (
        <>
            {loading &&
                <ProgressSpinner />
            }

            {!loading &&
                <Card className="surface-hover col-12 md:col-12" >
                    <div className=" formgroup-inline col-12 md:col-12">
                        <div className="col-3 md:col-3 ">
                            {!isOnTop() && <Button style={{ width: "100%" }} icon="pi pi-angle-double-up" label={getText("SPOSTA_NODO_TOP")} className="p-button-outlined p-button-primary p-button-rounded" onClick={nodoTop} />}
                            {isOnTop() && <Button style={{ width: "100%" }} icon="pi pi-angle-double-up" disabled label={getText("SPOSTA_NODO_TOP")} className="p-button-outlined p-button-primary p-button-rounded" onClick={nodoTop} />}
                        </div>
                        <div className="col-3 md:col-3 ">
                            {!isOnTop() && <Button style={{ width: "100%" }} icon="pi pi-angle-up" label={getText("SPOSTA_NODO_UP")} className="p-button-outlined p-button-primary p-button-rounded" onClick={nodoSu} />}
                            {isOnTop() && <Button style={{ width: "100%" }} disabled icon="pi pi-angle-up" label={getText("SPOSTA_NODO_UP")} className="p-button-outlined p-button-primary p-button-rounded" onClick={nodoSu} />}
                        </div>
                        <div className="col-3 md:col-3 ">
                            <Button style={{ width: "100%" }} icon="pi pi-angle-down" label={getText("SPOSTA_NODO_DOWN")} className="p-button-outlined p-button-primary p-button-rounded" onClick={nodoGiu} ></Button>
                        </div>
                        <div className="col-3 md:col-3 ">
                            <Button style={{ width: "100%" }} icon="pi pi-angle-double-down" label={getText("SPOSTA_NODO_BOTTOM")} className="p-button-outlined p-button-primary p-button-rounded" onClick={nodoBottom} />
                        </div>
                    </div>
                </Card>
            }
        </>
    )
}

export default SpostaNodo
